<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li><a href="#/empresas">EMPRESAS</a></li>
                    <li class="active">CADASTRO DA EMPRESA</li>
                </ol>

                <div class="col-md-3">
                    <menu-empresa></menu-empresa>
                </div>

                <div class="col-md-9" v-if="config">

                    <form class="form-horizontal">

                        <div class="panel panel-info">
                            <div class="panel-heading">DADOS DA EMPRESA</div>
                            <div class="panel-body">

                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <label for="senha" class="control-label">NOME:</label>
                                        <input id="senha" type="text" v-model="config.nome" class="form-control">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <label for="email" class="control-label">EMAIL:</label>
                                        <input id="email" type="text" v-model="config.email" class="form-control">
                                    </div>
                                </div>

                            </div>
                        </div>

                        <permissoes :permissoes="config.permissoes"></permissoes>

                        <street :disabled="false" :street="config.street"></street>

                        <div class="form-group">
                            <div class="col-sm-10">
                                <button type="button" @click="send()" class="btn btn-success">SALVAR EMPRESA</button>
                            </div>
                        </div>

                    </form>

                </div>

            </div>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import { Config, Usuario } from "../../class/index";
import { Street, Permissoes } from "../../components/exports";
import MenuEmpresa from "../../menus/empresa.vue";

export default {
    components: {
        Street,
        Permissoes,
        MenuEmpresa
    },
    data() {
        return {
            config: null
        };
    },
    beforeRouteEnter(to, from, next) {
        Usuario.level()
            .then(data => {
                if (data.level === 0) {
                    return next();
                }
                window.location.href = Vue.http.options.root;
            })
            .catch(() => {
                window.location.href = Vue.http.options.root;
            });
    },
    beforeMount() {
        Config.byPK(this.$route.params.id)
            .then(data => (this.config = data))
            .catch(err => {
                if (err.data.code === 401) {
                    window.location.href = Vue.http.options.root;
                }
                this.config = Config.create();
            });
    },
    methods: {
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a configuração?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Config.save(this.config)
                                .then(() => {
                                    this.$router.push("/empresas");
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
